import { apiClient } from '~/adapters/apiClient';
import log from '~/logger';
export const fetchStylesData = async (filterInfo, sortParam = 'sort=updateTimestamp(desc)') => {
    try {
        return await apiClient.fetchResourceWithFilter({
            endpoint: '/product_planning/styles/v1',
            filters: filterInfo,
            sortParam,
            resourceName: 'styles data',
            api: 'pulse-bff'
        });
    }
    catch (error) {
        log.error('Failed to fetch styles data', {
            error: error instanceof Error ? error.message : 'Unknown error',
            filters: filterInfo.filters
        });
        return { pages: { totalPages: 0, totalResources: 0 }, objects: [] };
    }
};
